export default page =>
  page.querySelectorAll('.dropdown:not(.dropdown--skip-js)').forEach(el => {
    el.addEventListener('click', () => {
      el.classList.add('dropdown--opened')
    })
    el.addEventListener('focusin', () => {
      el.classList.add('dropdown--opened')
    })
    el.addEventListener('focusout', () => {
      el.classList.remove('dropdown--opened')
    })
    document.documentElement.addEventListener('click', e => {
      if (!el.contains(e.target)) {
        el.classList.remove('dropdown--opened')
      }
    })
  })
